module.exports = __webpack_public_path__ + "static/media/milestone.f4c2d5a7.png";